<script setup>

import {storeToRefs} from "pinia";
import {useUserExerciseStore} from "@/stores/userExercise.store";
import UserResourceListComponent from "@/components/UserResourceListComponent";
import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/global.store";

const globalStore = useGlobalStore();
const exercisesStore = useUserExerciseStore();
const {exercises, type, name} = storeToRefs(exercisesStore);

onMounted(async () => {
    globalStore.loading = true;
    await exercisesStore.fetchAll();
    globalStore.loading = false;
});

const search = async (name) => {
    globalStore.loading = true;
    exercisesStore.name = name;
    await exercisesStore.fetchAll();
    globalStore.loading = false;
}

const updateType = async (type) => {
    globalStore.loading = true;
    exercisesStore.type = type;
    if (type === '') {
        exercisesStore.name = '';
    }
    await exercisesStore.fetchAll();
    globalStore.loading = false;
}

</script>

<template>
  <user-resource-list-component
      resource-id="exercise"
      :resource-name="name"
      :resource-type="type"
      :resource-list="exercises"
      :resource-types="[{
        id: '',
        icon: 'filter-o',
        name: 'All',
      }, {
        id: 'meditation',
        icon: 'hot-o',
        name: 'Meditation',
      }, {
        id: 'video',
        icon: 'video-o',
        name: 'Video',
      }, {
        id: 'audio',
        icon: 'volume-o',
        name: 'Audio',
      }, {
        id: 'reading',
        icon: 'orders-o',
        name: 'Reading',
      }, {
        id: 'journal',
        icon: 'edit',
        name: 'Journal',
      }]"
      @search="search"
      @updateType="updateType"
  ></user-resource-list-component>
</template>
